export const UiMessages = Object.freeze({
  virusBlocked: 'Please remove the rejected file and upload a new one.',
  statusEventName: 'statecourts-mus-upload-status-change',
  processingTitle: 'Uploading your files',
  processingText: 'Please wait while your files are uploaded and scanned for security.',
  playbackPreparingTitle: 'Your media is being prepared',
  playbackPreparingText: 'This may take a moment - thank you for your patience.',
  popupBlocked: 'Your browser blocked a pop-up window. Please allow pop-ups for this site and try again.',
  playbackMissingIds: 'We could not open the media player because some details are missing. Please try again or contact support.',
  playbackMissingUrl: 'The media player link is missing. Please try again.',
  playbackUnavailable: 'This case is now archived. File viewing and uploads are no longer available. If you need access to this information, please reach out to support',
  playbackLoadFailed: 'We could not load the media player. Please try again.',
  playbackOpenFailed: 'We could not open the media player. Please try again.',
  uploadBlockedTitle: 'Upload blocked',
  mediaFileInvalid: 'Media files must be in a supported audio or video format and under {maxFileSizeMb} MB.',
  transcriptFileInvalid: 'Transcript files must be in PDF format and under {maxFileSizeMb} MB.',
  authenticatedUploadRequired: 'We could not load your sign in information. Please sign in and try again.',
  caseUploadBlocked: 'This case is now archived. File viewing and uploads are no longer available. If you need access to this information, please reach out to support',
  applicationIdRequired: 'We could not identify the application. Please refresh the page or contact support.',
  caseIdRequired: 'We could not get the Case information. Please refresh the page or contact support.',
  allFilesUploaded: 'All of the selected files have already been uploaded successfully.',
  selectMediaFirst: 'Please select at least one media file to upload.',
  transcriptRequired: 'Please attach a PDF transcript to each row where transcripts are available.',
  uploadCancelled: 'Your upload was cancelled.',
  uploadFlowFailedPrefix: 'Upload failed',
  unknownError: 'Something went wrong. Please try again.',
  deleteMissingData: 'We could not delete this file at the moment. Please refresh and try again.',
  deleteRefreshFailed: 'The file was deleted, but we could not refresh the list. Please refresh the page to see the latest files.',
  caseFilesLoadFailedPrefix: 'Unable to load your case files',
  multipartBaseUrlMissing: 'The upload service is not configured correctly. Please contact support.',
  multipartStartFailed: 'We could not start the upload. Please try again.',
  multipartUrlMissing: 'A required upload address is missing. Please try again.',
  multipartEtagMissing: 'The upload could not be verified. Please try again.',
  multipartMaxRetryCount: '3',
  multipartRetryDelaySecond: '3',
  scanTimeout: 'The security scan is taking longer than expected. Please try again.',
  transcriptOptional: 'You may attach one PDF transcript to each media file. Transcripts are optional.',
  uploadedSummaryWithTranscript: 'Uploaded. Transcripts included',
  uploadedSummaryOptionalTranscript: 'Uploaded. Transcripts optional',
  uiLocked: 'Your files are being uploaded and scanned. Editing is temporarily unavailable.',
  transcriptNone: 'No transcript attached',
  transcriptAddAction: 'Add transcript',
  transcriptUploadSuccess: 'Transcript uploaded successfully.',
  transcriptUploadInProgress: 'Uploading transcript...',
  transcriptLabel: 'Transcript',
  deleteLocalMediaTitle: 'Remove file',
  deleteLocalMediaText: 'Remove this file from your upload list?',
  deleteLocalTranscriptTitle: 'Remove transcript',
  deleteLocalTranscriptText: 'Remove this transcript from your upload list?',
  deleteRemoteMediaTitle: 'Delete file',
  deleteRemoteMediaText: 'Are you sure you want to delete this file from the case? This cannot be undone.',
  deleteRemoteTranscriptTitle: 'Delete transcript',
  deleteRemoteTranscriptText: 'Delete this transcript? The media file will be kept.',
  deleteRefreshing: 'Refreshing your file list, please wait...',
  deleteInProgress: 'Deleting the file, please wait...',
  deleteTranscriptInProgress: 'Deleting the transcript, please wait...',
  buttonDelete: 'Delete',
  buttonCancel: 'Cancel',
  buttonOk: 'OK',
  transcriptIncluded: 'Transcript',
  mediaPreparingGenericError: 'Your media is still being prepared. Please try again in a moment.',
  noFilesYet: 'No files have been uploaded for this case yet.',
  pageTitle: 'Media Upload',
  pageIntro: 'You can upload up to {maxMediaFiles} files. Individual file size must not exceed {maxFileSizeMb} MB.',
  refreshing: 'Refreshing...',
  dropHint: 'Or drag and drop files here',
  chooseFiles: 'Choose files',
  confirmDeleteFileTitle: 'Remove file',
  confirmDeleteFileText: 'Remove this file from your upload list?',
  confirmDeleteCaseFileTitle: 'Delete file',
  confirmDeleteTranscriptTitle: 'Remove transcript',
  confirmDeleteTranscriptText: 'Remove this transcript from your upload list?',
  deleting: 'Deleting...'
});

export function formatMessage(template, values = {}) {
  return String(template || '').replaceAll(/\{(\w+)\}/g, (_, key) => String(values[key] ?? ''));
}

export function withReason(prefix, reason) {
  const detail = String(reason || '').trim();
  return detail ? `${prefix}: ${detail}` : prefix;
}
